import { useEnterpriseLogin } from '@features/applications/hooks/useEnterpriseLogin';
import { Button, TableCell, TableRow, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { FC } from 'react';

type Company = {
  id: Number;
  s_name: String;
  s_state: String;
  s_city: String;
  s_slug: String;
  plan: Number;
};

type RowData = {
  email: String;
  num_logins: String;
  last_login: Date;
  company: Company;
};
type ManageCompanyDataProps = {
  row: RowData;
};

const ManageCompanyData: FC<ManageCompanyDataProps> = ({ row }) => {
  const { enterpriseLogin } = useEnterpriseLogin();
  const handleEnterpriseLogin = () => {
    enterpriseLogin({ company_id: row.company.id });
  };

  const getLabel = (company: Company) => {
    switch (company.plan) {
      case 0:
        return 'Expired';
      case 999:
        return 'Unpaid';
      case 1:
      case 2:
      case 4:
        return 'Paid';
      case 3:
        return 'Paid';
      default:
        return '-';
    }
  };

  return (
    <TableRow>
      <TableCell>
        <Button
          onClick={handleEnterpriseLogin}
          variant="contained"
          size="small"
          color="green"
          sx={{ py: '8px', px: '15px' }}
        >
          <Typography
            fontSize="14px"
            component="span"
            lineHeight="1.1"
          >
            Manage
          </Typography>
        </Button>
      </TableCell>
      <TableCell>{row.company.s_name}</TableCell>
      <TableCell sx={{ wordBreak: 'break-all' }} align="left">{row.email}</TableCell>
      <TableCell>
        {row.company.s_city}, {row.company.s_state}
      </TableCell>
      <TableCell>{getLabel(row.company)}</TableCell>
      <TableCell>{row.num_logins}</TableCell>
      <TableCell>{dayjs(row.last_login).format('MM/DD/YY')}</TableCell>
      <TableCell>
        <a href={`${import.meta.env.VITE_MARKETING_SITE_URL}${row.company.s_slug}`} target="_blank" rel="noreferrer">
          Hiring Page
        </a>
      </TableCell>
    </TableRow>
  );
};

export default ManageCompanyData;
